module.exports = __webpack_public_path__ + "static/media/split.58562c82.webp";